import { portalMode } from '../../config';
import { PODLASKIE_MODE } from '../../constants'

function collectionHas(a, b) { // helper function (see below)
  for (var i = 0, len = a.length; i < len; i++) {
    if (a[i] == b) return true;
  }
  return false;
}
export default function findParentBySelector(elm, selector) {
  var all = document.querySelectorAll(selector);
  var cur = elm.parentNode;
  while (cur && !collectionHas(all, cur)) { // keep going up until you find a match
    cur = cur.parentNode; // go up
  }
  return cur; // will return null if not found
}

export const removeChildNode = (parentNode, childNodeClass) => {
  const chNodes = parentNode.childNodes;
  const chNodesArray = [...chNodes];
  const chNodeIndex = chNodesArray.findIndex(item => item.classList.contains(childNodeClass));
  // if (parentNode.childNodes[indexToRemove]) { parentNode.childNodes[indexToRemove].remove(); }
  if (parentNode.childNodes[chNodeIndex]) { parentNode.childNodes[chNodeIndex].style.display = 'none'; }
};

export const headerStyle = {
  normal: {
    backgroundColor: '#31485e',
    color: 'white',
  },
  intenseBlack: {
    backgroundColor: 'black',
    color: 'white',
  },
  intenseBlackYellow: {
    backgroundColor: 'black',
    color: 'yellow',
  },
  intenseYellowBlack: {
    backgroundColor: 'black',
    color: 'yellow',
  },
};

export const layoutColorStyle = {
  normal: {
    backgroundColor: portalMode == PODLASKIE_MODE ? '#FFFFFF' : '#f2f2f2',
    color: 'black',
  },
  intenseBlack: {
    backgroundColor: '#111212',
    color: 'white',
  },
  intenseBlackYellow: {
    backgroundColor: '#111212',
    color: 'yellow',
  },
  intenseYellowBlack: {
    backgroundColor: 'yellow',
    color: 'black',
  },
};

export const getThemeFromLocalStorage = () => {
  const cookie = localStorage.getItem('colorTheme') || 'normal';
  return cookie;
};

export const setFooterAndHeaderColors = (type=null) => {
  const colors = getThemeFromLocalStorage();
  let sourceStyle = headerStyle;
  let style = {
    color: sourceStyle[colors].color,
    backgroundColor: sourceStyle[colors].backgroundColor,
  };
  if (colors !== 'normal') {
    sourceStyle = headerStyle;
    style = {
      color: sourceStyle[colors].color,
      backgroundColor: sourceStyle[colors].backgroundColor,
    };
  }

  if (portalMode == PODLASKIE_MODE && colors == 'normal') {
    style = {
      color: type == 'footer' ? podlaskieFooterColor : podlaskieColor,
      backgroundColor: type == 'footer' ? podlaskieFooterBackgroundColor : podlaskieBackgroundColor
    };
  }

  return {colors, sourceStyle, style}
}

export const podlaskieColor = '#1D1E28';
export const podlaskieBackgroundColor = '#F3F3F4';
export const podlaskieFooterColor = '#FFFFFF';
export const podlaskieFooterBackgroundColor = '#1D1E28';
export const podlaskieLabelBackgroundColor = '#62B7FC';
export const podlaskieMainPageURL = 'https://ipodlaskie.pl/'

export const isMobileView = (window) => {
    return window.matchMedia('(max-width: 768px)').matches;
}

export const isTabletView = (window) => {
  return window.matchMedia('(min-width: 769px) and (max-width: 1024px)').matches;
}



// WEBPACK FOOTER //
// src/components/utils/utils.js